import React from "react";

import { FileInterface, Progress } from "../../types/common";

import FileItem from "./FileItem";

import styles from "./FileList.module.scss";

interface Props {
  files: FileInterface[];
  uploadProgressData?: Progress;
  onRemove?: (id: string) => void;
  onDownload?: (id: string, fileName: string) => void;
  disabled?: boolean;
  onDescriptionBlur?: (id: string, description: string) => void;
  onDescriptionChanged?: (id: string, description: string) => void;
  isDownloadActive?: boolean;
  isViewOnly?: boolean;
}

const defaultProps = {
  fn: () => {},
  obj: {},
};

const FileList = (props: Props) => {
  const {
    files,
    onRemove = defaultProps.fn,
    onDownload = defaultProps.fn,
    uploadProgressData = defaultProps.obj,
    onDescriptionBlur,
    onDescriptionChanged,
    disabled,
    isDownloadActive,
    isViewOnly,
  } = props;

  return files.length ? (
    <div className={styles.fileListWrapper}>
      {files.map(({ id, createdOn, ...otherProps }) => (
        <FileItem
          key={id}
          id={id}
          createdOn={createdOn ? new Date(createdOn) : undefined}
          {...otherProps}
          disabled={disabled || isViewOnly}
          onRemove={onRemove}
          onDownload={onDownload}
          progress={uploadProgressData[id]}
          isDownloadActive={isDownloadActive}
          onDescriptionBlur={onDescriptionBlur}
          onDescriptionChanged={onDescriptionChanged}
          isViewOnly={isViewOnly}
        />
      ))}
    </div>
  ) : null;
};

export default FileList;
